import React from 'react'

import * as config from 'styles/tailwind.config'

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'

import { withStyles } from '@material-ui/styles'
import IconButton from 'components/ui/iconButton'
import { More } from 'images/icons'

const StyledMenuItem = withStyles({
  root: {
    fontSize: config.theme.fontSize['10'],
    fontWeight: Number(config.theme.fontWeight['500']),
    letterSpacing: config.theme.letterSpacing['1.5'],
    textTransform: 'uppercase',
    color: config.theme.colors.black,
  },
})(MenuItem)

interface IPopUpOption {
  label: string
  function: () => void
}

interface IProps {
  className?: string
  options: IPopUpOption[]
}

const PopUpMenu: React.FC<IProps> = ({ options, className }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div className={className}>
      <IconButton className="py-5" aria-label="more" aria-haspopup="true" onClick={handleClick}>
        <More />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            borderRadius: 0,
            boxShadow: '0 2px 10px 0 rgba(0,0,0,0.1)',
          },
          elevation: 0,
        }}
        MenuListProps={{
          style: {
            padding: 0,
          },
        }}
      >
        {options.map(option => (
          <StyledMenuItem
            key={option.label}
            onClick={() => {
              option.function()
              handleClose()
            }}
          >
            {option.label}
          </StyledMenuItem>
        ))}
      </Menu>
    </div>
  )
}

export default PopUpMenu
